const pubblicazioni = () => {
    const blocks = document.querySelectorAll(".pubblicazioni__section");
    if (blocks.length > 0) {
      blocks.forEach((block) => {
        const container = block.querySelector(".container-fluid");
        if (container) {
          const slider = new Swiper(container, {
            slidesPerView: 1,
            spaceBetween: 20,
            loop: true,
            autoplay: {
              delay: 2500,
              disableOnInteraction: false,
            },
            breakpoints: {
              992: {
                slidesPerView: 2,
                spaceBetween: 40,
              },
            },
          });
        }
      });
    }
  };
  
  export default pubblicazioni;
  